<template>
  <div class="mapModal">
    <div
      class="mapImg"
      :style="{
        backgroundImage:
          'url(' +
          require('@/assets/images/StIves/maps/map' + (Selected + 1) + '.png') +
          ')',
      }"
    >
      <div class="modalCloseButton top" @click="closeModal">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: { Selected: Number },
  data() {
    return {};
  },

  methods: {
    closeModal() {
      this.$parent.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.mapModal {
  display: block;
  left: 0;
  right: 0;
  background-color: #fafafa;
  padding: 0;
  max-height: 70%;
  width: 65%;
  margin: auto;
  overflow-y: auto;
  margin-top: 3rem;

  border-radius: 2px;
  will-change: top, opacity;
  box-shadow: 0 0 24px 0;

  position: fixed;
  z-index: 10;
}

.mapImg {
  width: 100%;
  min-height: 70vh;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.modalCloseButton {
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: absolute;

  right: 10px;
  // border-radius: 10px;
  // background-color: #ffffff;
  // box-shadow: 0 0 5px 4px rgba(29, 50, 92, 0.07);
  &.top {
    top: 10px;
  }
  &.bottom {
    bottom: 10px;
  }
  i {
    font-size: 25px;
    padding: 7.5px;
    color: #4b789c;
  }
}
</style>
